import { render, staticRenderFns } from "./CoreSearch.vue?vue&type=template&id=47c6d28c&scoped=true&"
import script from "./CoreSearch.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreSearch.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreSearch.vue?vue&type=style&index=0&id=47c6d28c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6d28c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c6d28c')) {
      api.createRecord('47c6d28c', component.options)
    } else {
      api.reload('47c6d28c', component.options)
    }
    module.hot.accept("./CoreSearch.vue?vue&type=template&id=47c6d28c&scoped=true&", function () {
      api.rerender('47c6d28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreSearch/CoreSearch.vue"
export default component.exports